(function () {
  function init() {
    var sections = document.querySelectorAll('#MainContent .shopify-section');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      sections.forEach(function (section) {
        section.classList.add('scroll-reveal-visible');
      });
      return;
    }

    var revealedCount = 0;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var delay = Math.min(revealedCount * 60, 300);
          entry.target.style.setProperty('--reveal-delay', delay + 'ms');
          entry.target.classList.add('scroll-reveal-visible');
          revealedCount += 1;

          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });

    // Safety net: never let a section stay permanently invisible (IntersectionObserver
    // can miss very tall sections, viewport-height quirks on mobile browser chrome, etc).
    window.setTimeout(function () {
      sections.forEach(function (section) {
        section.classList.add('scroll-reveal-visible');
      });
    }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Horizon uses cross-document view transitions, and browser back/forward can land here
  // with the IntersectionObserver never (re-)firing for sections still above/below the
  // initial viewport — leaving the page stuck at opacity:0. On a confirmed back/forward
  // navigation, skip the animation and reveal everything immediately rather than risk that.
  window.addEventListener('pageshow', function () {
    var navEntries = window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation');
    var navType = navEntries && navEntries[0] && navEntries[0].type;
    if (navType !== 'back_forward') return;
    document.querySelectorAll('#MainContent .shopify-section').forEach(function (section) {
      section.classList.add('scroll-reveal-visible');
    });
  });
})();
